let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bzc8Q"), load("4TY0p")]).then(() => parcelRequire('ebxOW'));